import {
  PORTALUSERS_GET,
  PORTALUSER_GET,
  PORTALUSER_EDIT,
  PORTALUSER_DELETE,
  PORTALUSER_SYNC,
  PORTALUSER_REMOVE_USER,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    currentPage: '',
    searchText: '',
    itemPerPage: '',
  },
  items: [],
  portalusersSync: [],
  portalusersMerge: [],
};

const parsePortaluser = (item) => {
  let parsedDescription = item.description;
  if (typeof item.description === 'string') {
    try {
      parsedDescription = JSON.parse(item.description);
    } catch (e) {
      parsedDescription = {};
    }
  }
  return { ...item, description: parsedDescription };
};

const portalusersGet = (state, payload) => {
  const portalusers = payload.portalusers;
  return {
    total: portalusers.total,
    items: portalusers.items ? portalusers.items.map(parsePortaluser) : [],
    search: { ...portalusers.search },
  };
};

const portaluserGet = (state, payload) => {
  return {
    total: state.total,
    items: [
      ...state.items.filter(
        (i) => i.userId + '' !== payload.portaluser.userId + '',
      ),
      parsePortaluser(payload.portaluser),
    ],
    search: { ...state.search },
  };
};

const portaluserEdit = (state, payload) => {
  return {
    total: parseInt(state.total),
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.portaluser.id + ''),
      parsePortaluser(payload.portaluser),
    ],
    search: { ...state.search },
  };
};

const portaluserDelete = (state, payload) => {
  let item = state.items.find(
    (i) => i.userId + '' === payload.portaluser.userId + '',
  );

  if (!item) return;

  let updateItem = {
    ...item,
    messages: item?.messages?.filter(
      (m) => m.id + '' !== payload.portaluser.id + '',
    ),
  };

  return {
    total: parseInt(state.total),
    items: [
      ...state.items.filter(
        (i) => i.userId + '' !== payload.portaluser.userId + '',
      ),
      updateItem,
    ],
    search: { ...state.search },
  };
};

const portaluserRemoveUser = (state, payload) => {
  return {
    total: parseInt(state.total) - 1,
    items: state.items.filter((i) => i.id + '' !== payload.id + ''),
    portalusersMerge: state.portalusersMerge.filter((i) => i.id + '' !== payload.id + ''),
    portalusersSync: state.portalusersSync,
    search: { ...state.search },
  };
};

const portaluserSync = (state, payload) => {
  let dataPortalusersSync = payload?.portaluser?.portalusersSync;
  let dataPortalusersExisting = payload?.portaluser?.portalusers
    ? payload.portaluser.portalusers.map(parsePortaluser)
    : [];

  let portalusersMerge = [];
  for (const el of dataPortalusersSync) {
    let dataExist = dataPortalusersExisting?.find((dt) => {
      let matchNis = el.NIS && dt.description?.nis === el.NIS;
      let matchUserId = dt.userId + '' === el.USERID + '';
      return matchNis || matchUserId;
    });
    let id = '';
    let deviceId =
      el?.DEVICE_ID !== ''
        ? el.DEVICE_ID
        : dataExist?.deviceId && dataExist.deviceId !== ''
          ? dataExist?.deviceId
          : '';
    let newHistoryClass = [];
    if (dataExist) {
      id = dataExist.id;
      let historyClass = Array.isArray(dataExist?.description?.historyClass)
        ? dataExist.description.historyClass
        : [];
      newHistoryClass = [
        ...historyClass.filter((h) => h.class !== el.KELAS_AKTIF),
        {
          class: el.KELAS_AKTIF,
          updatedAt: new Date().toISOString(),
        },
      ];
    } else {
      newHistoryClass = [
        {
          class: el.KELAS_AKTIF,
          updatedAt: new Date().toISOString(),
        },
      ];
    }
    let existingDescription = dataExist?.description || {};

    portalusersMerge.push({
      id,
      deviceId,
      userId: el?.USERID,
      username: dataExist?.username ? dataExist.username : el?.VUSN || el.NIS,
      nis: el.NIS,
      name: el.NAMA_SISWA,
      activeClass: el.KELAS_AKTIF,
      description: {
        ...existingDescription,
        nis: el.NIS,
        noAbsen: el.NO_ABSEN,
        name: el.NAMA_SISWA,
        fatherName: el.NAMA_AYAH,
        fatherPhoneNumber: el.NO_HP_AYAH,
        motherName: el.NAMA_IBU,
        motherPhoneNumber: el.NO_HP_IBU,
        guardianName: el.NAMA_WALI,
        guardianPhoneNumber: el.NO_HP_WALI,
        activeClass: el.KELAS_AKTIF,
        historyClass: newHistoryClass,
      },
      selected: true,
      remark: dataExist ? 'Sync' : 'New',
    });
  }

  if (dataPortalusersExisting && dataPortalusersExisting.length > 0) {
    for (const existing of dataPortalusersExisting) {
      let foundInSync = dataPortalusersSync?.find((el) => {
        let matchNis = el.NIS && existing.description?.nis === el.NIS;
        let matchUserId = existing.userId + '' === el.USERID + '';
        return matchNis || matchUserId;
      });
      if (!foundInSync) {
        portalusersMerge.push({
          id: existing.id,
          deviceId: existing.deviceId,
          userId: existing.userId,
          username: existing.username,
          nis: existing.description?.nis || '',
          name: existing.description?.name || '',
          activeClass: existing.description?.activeClass || '',
          description: existing.description,
          selected: false,
          remark: 'Existing',
        });
      }
    }
  }

  return {
    ...state,
    items: [...payload?.portaluser?.portalusers],
    portalusersSync: [...payload?.portaluser?.portalusersSync],
    portalusersMerge: [...portalusersMerge],
  };
};

export default createReducer(initialState, {
  [PORTALUSERS_GET]: portalusersGet,
  [PORTALUSER_GET]: portaluserGet,
  [PORTALUSER_EDIT]: portaluserEdit,
  [PORTALUSER_DELETE]: portaluserDelete,
  [PORTALUSER_SYNC]: portaluserSync,
  [PORTALUSER_REMOVE_USER]: portaluserRemoveUser,
});
